import {
  Component,
  OnInit
}
from '@angular/core';

import {
  CommonModule
}
from '@angular/common';

import {
  FormsModule
}
from '@angular/forms';

import {
  HttpClient
}
from '@angular/common/http';

import {
  ProductsService
}
from '../../services/products';

@Component({
  selector: 'app-settings',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule
  ],

  templateUrl: './settings.html',

  styleUrl: './settings.scss'
})
export class Settings
implements OnInit
{
  model: any = {};

  apiUrl =
    'https://lazzaro-api1.onrender.com';

  constructor(
    private http: HttpClient,
    private productsService: ProductsService
  ) { }

  ngOnInit()
  {
    this.loadSettings();
  }

  loadSettings()
  {
    this.http.get<any>(
      `${this.apiUrl}/api/settings`
    )
    .subscribe({

      next: (res) =>
      {
        console.log(
          'Settings:',
          res
        );

        this.model =
          res || {};
      },

      error: (err) =>
      {
        console.log(err);
      }
    });
  }

  onFileSelected(event: any)
  {
    const file =
      event.target.files[0];

    if (!file)
      return;

    this.productsService
      .uploadImage(file)
      .subscribe({

        next: (response: any) =>
        {
          console.log(
            'Cloudinary:',
            response
          );

          this.model.heroImageUrl =
            response.secure_url;

          alert(
            'Slika je uspešno uploadovana.'
          );
        },

        error: (err) =>
        {
          console.log(err);

          alert(
            'Greška pri uploadu slike'
          );
        }
      });
  }

  save()
  {
    console.log(
      'Saving:',
      this.model
    );

    this.http.put(
      `${this.apiUrl}/api/settings`,
      this.model
    )
    .subscribe({

      next: (res) =>
      {
        console.log(res);

        alert(
          'Podešavanja uspešno sačuvana'
        );
      },

      error: (err) =>
      {
        console.log(err);

        alert(
          'Greška pri snimanju'
        );
      }
    });
  }
}